import {gql} from '@apollo/client'

export const EGOV_INFORMATION_COMPLETED = gql`
  query egovInformationCompleted {
    client {
      id
      egovInformationCompleted
    }
  }
`

export interface QueryResult {
  client: {
    egovInformationCompleted: boolean
  }
}
